import React from "react";

import { AgeBandedTobaccoRate } from "../../constants/aquafina";
import { CoverageArrowRow, CoverageRow } from "../table/rows";
import { CoverageCell, CoverageVectorCell } from "../table/cells";
import { RangeIterator } from "../../utils";

const AgeBandedTobaccoRates = ({
  rates,
}: {
  rates: AgeBandedTobaccoRate[];
}) => {
  const tiers = new Map<string, string[][]>();
  RangeIterator(rates.length, (index) => {
    rates[index]?.tiers?.forEach((tier) => {
      const tierName = tier.name;
      if (!tierName) return;
      if (!tiers.has(tierName)) {
        tiers.set(tierName, new Array(rates.length).fill(["", ""]));
      }
      (tiers.get(tierName) as string[][])[index] = [
        tier.nonTobacco,
        tier.tobacco,
      ];
    });
  });
  return (
    <>
      <CoverageRow label="Rate Unit" isWhite>
        {RangeIterator(rates.length, (index) => (
          <CoverageCell value={rates[index].rateUnit} key={index} />
        ))}
      </CoverageRow>
      <CoverageRow label="Rates">
        {RangeIterator(rates.length, (index) => (
          <CoverageVectorCell value={["Non-Tobacco", "Tobacco"]} key={index} />
        ))}
      </CoverageRow>
      {Array.from(tiers.entries()).map(([label, values], indexTier) => (
        <CoverageArrowRow
          key={label}
          label={label}
          level={2}
          isWhite={indexTier % 2 === 0}
        >
          {values.map((value, index) => (
            <CoverageVectorCell value={value} key={index} />
          ))}
        </CoverageArrowRow>
      ))}
    </>
  );
};

export default AgeBandedTobaccoRates;
